/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Coloutput2Inputs */

const zh_adminthreads_coloutput2 = /** @type {(inputs: Adminthreads_Coloutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出`)
};

const en_adminthreads_coloutput2 = /** @type {(inputs: Adminthreads_Coloutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

const es_adminthreads_coloutput2 = /** @type {(inputs: Adminthreads_Coloutput2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado`)
};

/**
* | output |
* | --- |
* | "Output" |
*
* @param {Adminthreads_Coloutput2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_coloutput2 = /** @type {((inputs?: Adminthreads_Coloutput2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Coloutput2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_coloutput2(inputs)
	if (locale === "en") return en_adminthreads_coloutput2(inputs)
	return es_adminthreads_coloutput2(inputs)
});
export { adminthreads_coloutput2 as "adminThreads_colOutput" }